<template>
  <div>
    <CRow class="mb-3 search-panel"> 
      <CCol sm="12" xs="12" md="12" lg="12" xl="2">
        <BaseInput
          :options="codeInput.options"
          :data="codeInput.data"
          :listener="codeInput.listener"
        />
      </CCol>
      <CCol sm="12" xs="12" md="12" lg="12" xl="2">
        <BaseInput
          :options="nameInput.options"
          :data="nameInput.data"
          :listener="nameInput.listener"
        />
      </CCol>

      <CCol sm="12" xs="12" md="6" lg="6" xl="2">
        <BaseSelect
          :options="statusSelect.options"
          :data="statusSelect.data"
          ref="status"
        >
        </BaseSelect>
      </CCol>

      <CCol sm="12" xs="12" md="6" lg="6" xl="2">
        <BaseSelect
          :options="isActiveSelect.options"
          :data="isActiveSelect.data"
          ref="isActive"
        >
        </BaseSelect>
      </CCol>
      <CCol>
        <CButton
          style="float: right;margin-left: 5px;"
          color="primary"
          v-c-tooltip.hover="'Tìm kiếm'"
          class="btn-action-primary"
          @click="loadDataMainTable(true)">
          <i class="fa fa-search"></i>&nbsp;&nbsp; Tìm kiếm
        </CButton>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listProductSelected"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>

          <template #stt="{index}">
            <td>{{$refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #price="{item}">
            <td>
              <span>{{ $helper.formatPrice(item.price) + "đ" }}</span>
            </td>
          </template>

          <template #priceSale="{item}">
            <td>
              <span>{{ $helper.formatPrice(item.price - item.price * item.discount / 100) + "đ" }}</span>
            </td>
          </template>
          

          <template #status="{item}">
            <td>
              <span v-if="item.status == false" class="dot-custom dot-danger">Hết hàng</span>
              <span v-else-if="item.status == true" class="dot-custom dot-success">Còn hàng</span>
            </td>
          </template>

          <template #active="{item}">
            <td>
              <span v-if="item.active == false" class="dot-custom dot-danger">Không hoạt động</span>
              <span v-else-if="item.active == true" class="dot-custom dot-success">Hoạt động</span>
            </td>
          </template>

          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click=" setupSelectOneAction('delete_one', item.productSaleProgramId, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm
      :actionTypeMapping="actionData.actionTypeMapping"
      ref="actionModal"
    >
    </ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";

export default {
  name: "ProductSaleProgramList",
  components: {BaseTable, ModalConfirm, BaseInput, BaseSelect},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    var that = this;
    var actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/product-sale-program/deleteById",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "sản phẩm",
          that.actionData.model.name
        );
      },
      dataSubmit: function () {
        return {
          id: that.actionData.model.id
        };
      },
      successCallback: function () {
        that.actionData.model.listProductSelected = [];
        that.showSuccessMsg({
          message: "Xóa sản phẩm thành công"
        });
        that.loadDataMainTable();
      },
      isJsonContentType: false
    });

    return {
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          id: null,
          listProductSelected: []
        }
      },
      saleProgramId: {
        data: {
          model: that.$route.params.id,
          name: "saleProgramId"
        }
      },
      codeInput: {
        options: {
          placeholder: "Mã sản phẩm",
          label: 'Mã sản phẩm'
        },
        data: {
          name: "productCode",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên sản phẩm",
          label: 'Tên sản phẩm'
        },
        data: {
          name: "productName",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "productActive",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "true", value: "Hoạt động"},
            {key: "false", value: "Không hoạt động"},
          ],
          model: 'null',
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      statusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái sản phẩm',
        },
        data: {
          name: "productStatus",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "true", value: "Còn hàng"},
            {key: "false", value: "Hết hàng"},
          ],
          model: 'null',
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            // {key: "checkbox", label: "#"},
            {key: "stt", label: "STT"},
            {key: "code", label: "Mã sản phẩm"},
            {key: "name", label: "Tên sản phẩm"},
            {key: "price", label: "Giá sản phẩm"},
            {key: "priceSale", label: "Giá giảm"},
            {key: "status", label: "Trạng thái sản phẩm"},
            {key: "active", label: "Trạng thái"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["checkbox","stt", "status", "active", "action", "price", "priceSale"],
          pageSize: 20
        },
        dataSource: {
          url: "/product-sale-program/pageProductBySaleProgramId",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data)
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listProductSelected = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listProductSelected.push(each.id);
        });
      } else {
        this.actionData.model.listProductSelected = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, id, name) {
      var actionData = this.actionData.model;
      actionData.id = id || null;
      actionData.name = name;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    setupSelectMoreAction: function (actionTypeKey) {
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listProductSelected": function (newValue) {
      var that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
